// Mock data for Unit Converters clone

export const expressCategories = [
  { id: 'length', label: 'Length', icon: 'Ruler' },
  { id: 'temperature', label: 'Temperature', icon: 'Thermometer' },
  { id: 'area', label: 'Area', icon: 'Square' },
  { id: 'volume', label: 'Volume', icon: 'Box' },
  { id: 'weight', label: 'Weight', icon: 'Scale' },
  { id: 'time', label: 'Time', icon: 'Clock' }
];

export const unitsByCategory = {
  length: [
    { id: 'meter', name: 'Meter', symbol: 'm', factor: 1 },
    { id: 'kilometer', name: 'Kilometer', symbol: 'km', factor: 1000 },
    { id: 'centimeter', name: 'Centimeter', symbol: 'cm', factor: 0.01 },
    { id: 'millimeter', name: 'Millimeter', symbol: 'mm', factor: 0.001 },
    { id: 'micrometer', name: 'Micrometer', symbol: 'μm', factor: 0.000001 },
    { id: 'nanometer', name: 'Nanometer', symbol: 'nm', factor: 0.000000001 },
    { id: 'mile', name: 'Mile', symbol: 'mi', factor: 1609.344 },
    { id: 'yard', name: 'Yard', symbol: 'yd', factor: 0.9144 },
    { id: 'foot', name: 'Foot', symbol: 'ft', factor: 0.3048 },
    { id: 'inch', name: 'Inch', symbol: 'in', factor: 0.0254 },
    { id: 'light-year', name: 'Light Year', symbol: 'ly', factor: 9460730472580800 }
  ],
  temperature: [
    { id: 'celsius', name: 'Celsius', symbol: '°C', type: 'temperature' },
    { id: 'fahrenheit', name: 'Fahrenheit', symbol: '°F', type: 'temperature' },
    { id: 'kelvin', name: 'Kelvin', symbol: 'K', type: 'temperature' },
    { id: 'rankine', name: 'Rankine', symbol: '°R', type: 'temperature' }
  ],
  area: [
    { id: 'sqmeter', name: 'Square Meter', symbol: 'm²', factor: 1 },
    { id: 'sqkilometer', name: 'Square Kilometer', symbol: 'km²', factor: 1000000 },
    { id: 'sqcentimeter', name: 'Square Centimeter', symbol: 'cm²', factor: 0.0001 },
    { id: 'sqmillimeter', name: 'Square Millimeter', symbol: 'mm²', factor: 0.000001 },
    { id: 'sqmile', name: 'Square Mile', symbol: 'mi²', factor: 2589988.110336 },
    { id: 'sqyard', name: 'Square Yard', symbol: 'yd²', factor: 0.83612736 },
    { id: 'sqfoot', name: 'Square Foot', symbol: 'ft²', factor: 0.09290304 },
    { id: 'sqinch', name: 'Square Inch', symbol: 'in²', factor: 0.00064516 },
    { id: 'hectare', name: 'Hectare', symbol: 'ha', factor: 10000 },
    { id: 'acre', name: 'Acre', symbol: 'ac', factor: 4046.8564224 }
  ],
  volume: [
    { id: 'cubicmeter', name: 'Cubic Meter', symbol: 'm³', factor: 1 },
    { id: 'cubickilometer', name: 'Cubic Kilometer', symbol: 'km³', factor: 1000000000 },
    { id: 'cubiccentimeter', name: 'Cubic Centimeter', symbol: 'cm³', factor: 0.000001 },
    { id: 'cubicmillimeter', name: 'Cubic Millimeter', symbol: 'mm³', factor: 0.000000001 },
    { id: 'liter', name: 'Liter', symbol: 'L', factor: 0.001 },
    { id: 'milliliter', name: 'Milliliter', symbol: 'mL', factor: 0.000001 },
    { id: 'gallon-us', name: 'US Gallon', symbol: 'gal', factor: 0.003785411784 },
    { id: 'quart-us', name: 'US Quart', symbol: 'qt', factor: 0.000946352946 },
    { id: 'pint-us', name: 'US Pint', symbol: 'pt', factor: 0.000473176473 },
    { id: 'cup-us', name: 'US Cup', symbol: 'cup', factor: 0.0002365882365 },
    { id: 'fluid-ounce', name: 'US Fluid Ounce', symbol: 'fl oz', factor: 0.0000295735295625 }
  ],
  weight: [
    { id: 'kilogram', name: 'Kilogram', symbol: 'kg', factor: 1 },
    { id: 'gram', name: 'Gram', symbol: 'g', factor: 0.001 },
    { id: 'milligram', name: 'Milligram', symbol: 'mg', factor: 0.000001 },
    { id: 'metric-ton', name: 'Metric Ton', symbol: 't', factor: 1000 },
    { id: 'pound', name: 'Pound', symbol: 'lb', factor: 0.45359237 },
    { id: 'ounce', name: 'Ounce', symbol: 'oz', factor: 0.028349523125 },
    { id: 'carat', name: 'Carat', symbol: 'ct', factor: 0.0002 },
    { id: 'ton-us', name: 'US Ton', symbol: 'ton', factor: 907.18474 },
    { id: 'stone', name: 'Stone', symbol: 'st', factor: 6.35029318 }
  ],
  time: [
    { id: 'second', name: 'Second', symbol: 's', factor: 1 },
    { id: 'millisecond', name: 'Millisecond', symbol: 'ms', factor: 0.001 },
    { id: 'microsecond', name: 'Microsecond', symbol: 'μs', factor: 0.000001 },
    { id: 'nanosecond', name: 'Nanosecond', symbol: 'ns', factor: 0.000000001 },
    { id: 'minute', name: 'Minute', symbol: 'min', factor: 60 },
    { id: 'hour', name: 'Hour', symbol: 'h', factor: 3600 },
    { id: 'day', name: 'Day', symbol: 'd', factor: 86400 },
    { id: 'week', name: 'Week', symbol: 'wk', factor: 604800 },
    { id: 'month', name: 'Month', symbol: 'mo', factor: 2628000 },
    { id: 'year', name: 'Year', symbol: 'yr', factor: 31536000 }
  ]
};

export const commonConversions = [
  { from: 'cm', to: 'inches', category: 'length' },
  { from: 'kg', to: 'lbs', category: 'weight' },
  { from: 'Celsius', to: 'Fahrenheit', category: 'temperature' },
  { from: 'mm', to: 'inches', category: 'length' },
  { from: 'meters', to: 'feet', category: 'length' },
  { from: 'km', to: 'miles', category: 'length' },
  { from: 'cm', to: 'feet', category: 'length' },
  { from: 'grams', to: 'ounces', category: 'weight' },
  { from: 'inches', to: 'feet', category: 'length' },
  { from: 'liters', to: 'gallons', category: 'volume' },
  { from: 'pounds', to: 'ounces', category: 'weight' },
  { from: 'mph', to: 'kph', category: 'speed' },
  { from: 'acres', to: 'square feet', category: 'area' },
  { from: 'radians', to: 'degrees', category: 'angle' },
  { from: 'hp', to: 'kw', category: 'power' },
  { from: 'meters', to: 'yards', category: 'length' },
  { from: 'mL', to: 'cups', category: 'volume' },
  { from: 'inches', to: 'cm', category: 'length' },
  { from: 'lbs', to: 'kg', category: 'weight' },
  { from: 'Fahrenheit', to: 'Celsius', category: 'temperature' },
  { from: 'inches', to: 'mm', category: 'length' },
  { from: 'feet', to: 'meters', category: 'length' },
  { from: 'miles', to: 'km', category: 'length' },
  { from: 'feet', to: 'cm', category: 'length' },
  { from: 'ounces', to: 'grams', category: 'weight' },
  { from: 'feet', to: 'inches', category: 'length' },
  { from: 'gallons', to: 'liters', category: 'volume' },
  { from: 'ounces', to: 'pounds', category: 'weight' },
  { from: 'kph', to: 'mph', category: 'speed' },
  { from: 'square feet', to: 'acres', category: 'area' },
  { from: 'degrees', to: 'radians', category: 'angle' },
  { from: 'kw', to: 'hp', category: 'power' },
  { from: 'yards', to: 'meters', category: 'length' },
  { from: 'cups', to: 'mL', category: 'volume' }
];

export const converterCategories = {
  common: {
    title: 'Common Converters',
    items: [
      { id: 'length', name: 'Length Converter', icon: 'Ruler' },
      { id: 'weight', name: 'Weight and Mass Converter', icon: 'Scale' },
      { id: 'volume', name: 'Volume Converter', icon: 'Box' },
      { id: 'temperature', name: 'Temperature Converter', icon: 'Thermometer' },
      { id: 'area', name: 'Area Converter', icon: 'Square' },
      { id: 'pressure', name: 'Pressure Converter', icon: 'Gauge' },
      { id: 'energy', name: 'Energy Converter', icon: 'Zap' },
      { id: 'volume-dry', name: 'Volume - Dry Converter', icon: 'Package' },
      { id: 'currency', name: 'Currency Converter', icon: 'DollarSign' },
      { id: 'case', name: 'Case Converter', icon: 'Type' },
      { id: 'power', name: 'Power Converter', icon: 'Bolt' },
      { id: 'force', name: 'Force Converter', icon: 'ArrowRight' },
      { id: 'time', name: 'Time Converter', icon: 'Clock' },
      { id: 'speed', name: 'Speed Converter', icon: 'Zap' },
      { id: 'angle', name: 'Angle Converter', icon: 'Triangle' },
      { id: 'fuel', name: 'Fuel Consumption Converter', icon: 'Fuel' },
      { id: 'numbers', name: 'Numbers Converter', icon: 'Hash' },
      { id: 'data-storage', name: 'Data Storage Converter', icon: 'HardDrive' }
    ]
  },
  engineering: {
    title: 'Engineering Converters',
    items: [
      { id: 'velocity-angular', name: 'Velocity - Angular Converter' },
      { id: 'acceleration', name: 'Acceleration Converter' },
      { id: 'acceleration-angular', name: 'Acceleration - Angular Converter' },
      { id: 'density', name: 'Density Converter' },
      { id: 'specific-volume', name: 'Specific Volume Converter' },
      { id: 'moment-inertia', name: 'Moment of Inertia Converter' },
      { id: 'moment-force', name: 'Moment of Force Converter' },
      { id: 'torque', name: 'Torque Converter' }
    ]
  },
  heat: {
    title: 'Heat Converters',
    items: [
      { id: 'fuel-efficiency-mass', name: 'Fuel Efficiency - Mass Converter' },
      { id: 'fuel-efficiency-volume', name: 'Fuel Efficiency - Volume Converter' },
      { id: 'temperature-interval', name: 'Temperature Interval Converter' },
      { id: 'thermal-expansion', name: 'Thermal Expansion Converter' },
      { id: 'thermal-resistance', name: 'Thermal Resistance Converter' },
      { id: 'thermal-conductivity', name: 'Thermal Conductivity Converter' },
      { id: 'specific-heat-capacity', name: 'Specific Heat Capacity Converter' },
      { id: 'heat-density', name: 'Heat Density Converter' },
      { id: 'heat-flux-density', name: 'Heat Flux Density Converter' },
      { id: 'heat-transfer-coefficient', name: 'Heat Transfer Coefficient Converter' }
    ]
  },
  fluids: {
    title: 'Fluids Converters',
    items: [
      { id: 'flow', name: 'Flow Converter' },
      { id: 'flow-mass', name: 'Flow - Mass Converter' },
      { id: 'flow-molar', name: 'Flow - Molar Converter' },
      { id: 'mass-flux-density', name: 'Mass Flux Density Converter' },
      { id: 'concentration-molar', name: 'Concentration - Molar Converter' },
      { id: 'concentration-solution', name: 'Concentration - Solution Converter' },
      { id: 'viscosity-dynamic', name: 'Viscosity - Dynamic Converter' },
      { id: 'viscosity-kinematic', name: 'Viscosity - Kinematic Converter' },
      { id: 'surface-tension', name: 'Surface Tension Converter' },
      { id: 'permeability', name: 'Permeability Converter' }
    ]
  },
  light: {
    title: 'Light Converters',
    items: [
      { id: 'luminance', name: 'Luminance Converter' },
      { id: 'luminous-intensity', name: 'Luminous Intensity Converter' },
      { id: 'illumination', name: 'Illumination Converter' },
      { id: 'digital-image-resolution', name: 'Digital Image Resolution Converter' },
      { id: 'frequency-wavelength', name: 'Frequency Wavelength Converter' }
    ]
  },
  electricity: {
    title: 'Electricity Converters',
    items: [
      { id: 'charge', name: 'Charge Converter' },
      { id: 'linear-charge-density', name: 'Linear Charge Density Converter' },
      { id: 'surface-charge-density', name: 'Surface Charge Density Converter' },
      { id: 'volume-charge-density', name: 'Volume Charge Density Converter' },
      { id: 'current', name: 'Current Converter' },
      { id: 'linear-current-density', name: 'Linear Current Density Converter' },
      { id: 'surface-current-density', name: 'Surface Current Density Converter' },
      { id: 'electric-field-strength', name: 'Electric Field Strength Converter' },
      { id: 'electric-potential', name: 'Electric Potential Converter' },
      { id: 'electric-resistance', name: 'Electric Resistance Converter' },
      { id: 'electric-resistivity', name: 'Electric Resistivity Converter' },
      { id: 'electric-conductance', name: 'Electric Conductance Converter' },
      { id: 'electric-conductivity', name: 'Electric Conductivity Converter' },
      { id: 'electrostatic-capacitance', name: 'Electrostatic Capacitance Converter' },
      { id: 'inductance', name: 'Inductance Converter' }
    ]
  },
  magnetism: {
    title: 'Magnetism Converters',
    items: [
      { id: 'magnetomotive-force', name: 'Magnetomotive Force Converter' },
      { id: 'magnetic-field-strength', name: 'Magnetic Field Strength Converter' },
      { id: 'magnetic-flux', name: 'Magnetic Flux Converter' },
      { id: 'magnetic-flux-density', name: 'Magnetic Flux Density Converter' }
    ]
  },
  radiology: {
    title: 'Radiology Converters',
    items: [
      { id: 'radiation', name: 'Radiation Converter' },
      { id: 'radiation-activity', name: 'Radiation-Activity Converter' },
      { id: 'radiation-exposure', name: 'Radiation-Exposure Converter' },
      { id: 'radiation-absorbed-dose', name: 'Radiation-Absorbed Dose Converter' }
    ]
  },
  other: {
    title: 'Other Converters',
    items: [
      { id: 'prefixes', name: 'Prefixes Converter' },
      { id: 'data-transfer', name: 'Data Transfer Converter' },
      { id: 'sound', name: 'Sound Converter' },
      { id: 'typography', name: 'Typography Converter' },
      { id: 'volume-lumber', name: 'Volume - Lumber Converter' }
    ]
  }
};

export const sidebarCategories = [
  'Common Converters',
  'Engineering Converters',
  'Heat Converters',
  'Fluids Converters',
  'Light Converters',
  'Electricity Converters',
  'Magnetism Converters',
  'Radiology Converters',
  'Common Unit Systems'
];
